import React, { useState, useCallback } from 'react';
import t from '~t';
import config from '~config';
import { useDispatch } from 'react-redux';
import { clientCreate } from '~data/actions/oauth';

import { Icon, Layout, Label, Text, Checkbox, ButtonRow, Button, Item, ItemIcon, ItemTitle, Modal, ModalHeader as Header, ModalContent as Content } from '~ui';
import { Error } from '~co/overlay/dialog';

export default function DevCreate() {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const title = t.s('createNewApp');

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      setLoading(true);

      dispatch(
        clientCreate(
          { name },
          () => {
            setLoading(false);
            setShow(false);
          },
          (e) => {
            setLoading(false);
            Error(e);
          },
        ),
      );
    },
    [dispatch, name],
  );

  const onShowClick = useCallback((e) => {
    e.preventDefault();
    setShow(true);
  }, []);

  const onCloseClick = useCallback(() => setShow(false), []);

  return (
    <>
      <Item as='a' href='' onClick={onShowClick}>
        <ItemIcon>
          <Icon name='add' />
        </ItemIcon>
        <ItemTitle>{title}</ItemTitle>
      </Item>

      {show && (
        <Modal onClose={onCloseClick}>
          <Header title={title} />

          <Content>
            <form onSubmit={onSubmit}>
              <Layout>
                <Label>{t.s('name')}</Label>
                <Text
                  autoFocus
                  required
                  disabled={loading}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />

                <Checkbox required disabled={loading}>
                  I accept the{' '}
                  <a href={config.links.dev.terms} target='_blank'>
                    Save API Terms & Guidelines
                  </a>
                </Checkbox>

                <ButtonRow>
                  <Button type='submit' disabled={loading}>
                    {t.s('create')}
                  </Button>
                </ButtonRow>
              </Layout>
            </form>
          </Content>
        </Modal>
      )}
    </>
  );
}
